import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Styles
import classes from './AdminNav.scss'

// Actions
import { userActions } from 'redux/actionCreators'

// Helpers
import _get from 'lodash.get'

const mapStateToProps = (state) => ({
  role: _get(state, ['user', 'me', 'role'])
})
const mapDispatchToProps = (dispatch) => ({
  attemptLogout: () =>
    dispatch(userActions.attemptLogout()),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
})

@connect(mapStateToProps, mapDispatchToProps)
class AdminNav extends Component {
  static propTypes = { children: PropTypes.any };
  static contextTypes = { router: PropTypes.object.isRequired };

  componentWillReceiveProps (nextProps) {
    if (this.props.role !== nextProps.role && nextProps.role !== 'admin') {
      this.context.router.replace('/')
    }
  }

  render () {
    const { role, attemptLogout } = this.props
    return role === 'admin' && (
      <div>
        <div className={classes.navBar}>
          <div className={classes.menus}>
            <Link to='/admin/orders' activeClassName={classes.active}>รายการสั่งซื้อ</Link>
            <Link to='/admin/payment' activeClassName={classes.active}>แจ้งโอนเงิน</Link>
            <Link to='/admin/products' activeClassName={classes.active}>รายการสินค้า</Link>
            <Link to='/admin/promocodes' activeClassName={classes.active}>โค้ดส่วนลด</Link>
            <Link to='/admin/giveaways' activeClassName={classes.active}>สินค้าแถม</Link>
            {/* <Link to='/admin/rewards' activeClassName={classes.active}>รางวัล</Link> */}
            <Link to='/admin/customers' activeClassName={classes.active}>รายชื่อลูกค้า</Link>
            <Link to='/admin/companies' activeClassName={classes.active}>รายชื่อบริษัท</Link>
            <Link to='/admin/setting' activeClassName={classes.active}>ตั้งค่า</Link>
            <a onClick={attemptLogout}>ออกจากระบบ</a>
          </div>
        </div>
        <div className={classes.body}>{this.props.children}</div>
      </div>
    )
  }
}

export default AdminNav



/** WEBPACK FOOTER **
 ** ./src/containers/Admin/AdminNav.js
 **/